import { combine, createEffect, createStore, sample } from "effector";
import { createGate } from "effector-react";
import { status } from "patronum";

import * as api from "src/shared/api";
import { fetchReportsFx } from "src/screens/protected/history-screen/model";

import type { InfoKey } from "./index.d";
import { $user, UserGate } from "src/entities/user/model";

export type Alarm = {
  accepted: boolean;
  id: number;
  latitude: number;
  longitude: number;
};

export const HomeGate = createGate("home page gate");

export const $infoKeys = createStore<InfoKey>({});
export const $publicArcgisSettings = createStore<Record<string, any>>({});
export const $vnp = createStore<Record<string, any>[]>([]);
export const $locations = createStore<Alarm[]>([]);

const fetchKeysFx = createEffect(async () => {
  const response = await api.get("info/");

  return await response.data;
});

const fetchVnpFx = createEffect(async () => {
  const response = await api.get("vnpInfo/");
  return await response.data;
});

const fetchLocationFx = createEffect(async () => {
  const response = await api.get("location/");
  return await response.data;
});

const fetchPublicArcgisSettingsFx = createEffect(async function () {
  const response = await api.get("react_arcgis_settings_2/");

  return await response.data;
});

sample({
  clock: UserGate.open,
  target: [fetchPublicArcgisSettingsFx],
});

sample({
  clock: HomeGate.open,
  target: [fetchKeysFx, fetchVnpFx, fetchLocationFx],
});

sample({
  clock: HomeGate.open,
  source: $user,
  filter: (user) => {
    return !!user?.id;
  },
  target: fetchReportsFx,
});

sample({
  source: fetchVnpFx.doneData,
  target: $vnp,
});

sample({
  source: fetchKeysFx.doneData,
  target: $infoKeys,
});

sample({
  clock: fetchPublicArcgisSettingsFx.doneData,
  target: $publicArcgisSettings,
});

sample({
  source: fetchLocationFx.doneData,
  target: $locations,
});

const $status = status({
  effect: fetchKeysFx,
});

const $publicArcgisSettingsStatus = status({
  effect: fetchPublicArcgisSettingsFx,
});

export const $isLoading = combine($status, $publicArcgisSettingsStatus).map(
  (statuses) => statuses.some((s) => s === "pending")
);

export const $acceptedAlarms = $locations.map((locations) =>
  locations.filter((loc) => loc.accepted)
);

export const $createdAlarms = $locations.map((locations) =>
  locations.filter((loc) => !loc.accepted)
);

export const $isMapSettingsLoaded = $publicArcgisSettingsStatus.map(
  (status) => status === "done"
);
